export const cloneDeep = (obj: any) => {
    return JSON.parse(JSON.stringify(obj))
}